<template>
  <component :is="way" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import PROCESS_NAMES from "@/process/names";
import RepeatedModalDefault from "./default";
const RepeatedModalSibur = () =>
  import(/* webpackChunkName: "sibur-test" */ "@/process/sibur-test/components/invites/creation/RepeatedModal.vue");

export default {
  name: "repeated-modal-wrapper",
  components: {
    "repeated-modal-default": RepeatedModalDefault,
    "repeated-modal-sibur": RepeatedModalSibur
  },
  computed: {
    way() {
      let way = "repeated-modal";

      if (
        this.$store.getters["invites/creation/hasProcess"](
          PROCESS_NAMES.SIBUR_TEST
        )
      ) {
        return `${way}-sibur`;
      }

      return `${way}-default`;
    }
  }
};
</script>
